export default __webpack_public_path__ + "static/media/limit_45.83224ea2.svg";